<template>
  <div class="root">
    <AceEditor
      :fontSize="13"
      :showGutter="true"
      :highlightActiveLine="false"
      :showPrintMargin="false"
      mode="csharp"
      height="100%"
      width="100%"
      theme="iplastic"
      :onChange="onChange"
      :value="formula"
      name="editor"
    />
    <div class="floating-section">
      <formula-variables v-if="variables"/>
      <button class="btn-floating" ref="fomulaBtn" @click="prettifyFormula">
        Format
      </button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import jsbeautify from "js-beautify";
import { Ace as AceEditor } from "vue2-brace-editor";
import "brace/theme/xcode";
import "brace/theme/iplastic";
import "brace/mode/csharp";
import "brace/mode/javascript";

import FormulaVariables from "./variables.vue";

export default {
  components: { AceEditor, FormulaVariables },
  props: {
    formula: {
      type: String,
      default: "",
      require: true,
    },
  },
  computed:{
    ...mapGetters(["variables"])
  },
  methods: {
    prettifyFormula: function () {
      try {
        const prettified = jsbeautify(this.formula);
        this.$emit("update:formula", prettified);
      } catch (error) {
        console.log(error);
      }
    },
    onChange: function (newValue) {
      try {
        this.$emit("update:formula", newValue);
      } catch (error) {}
    },
  },
};
</script>

<style>
.ace-iplastic div.ace_gutter {
  background: #ebebeb;
}
.ace-iplastic .ace_indent-guide {
    opacity: 0.4;
}
</style>
<style scoped>
.ace-iplastic {
  background-color: #fff;
}
.root {
  flex-grow: 1;
  border: solid 1px #cccccc;
  position: relative;
}

.btn-floating {
  padding: 6px 12px;
  background-color: transparent;
  border: solid #4e63ff36 1px;
  color: rgba(51, 51, 51, 0.22);
}

.btn-floating:hover {
  z-index: 1;
  animation: pulse 0.3s;
  text-decoration: none;
  transform: scale(1.015);
  color: rgba(51, 51, 51);
  background-color: white;
  border: solid #4e63ffe8 1px;
}

@keyframes pulse {
  0% {
    border: solid #4e63ff36 1px;
    color: rgba(51, 51, 51, 0.22);
    background-color: transparent;
  }
  100% {
    border: solid #4e63ffe8 1px;
    color: rgba(51, 51, 51);
    background-color: white;
  }
}

.floating-section {
  gap: 16px;
  z-index: 2;
  width: 100%;
  bottom: 60px;
  display: flex;
  position: absolute;
  padding-right: 16px;
  pointer-events: none;
  justify-content: flex-end;
}

.floating-section > div,button {
  pointer-events: auto;
}
</style>
